import { css } from 'lit';
export default css`
  .select-container {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 40px;
    background-color: #fff;
    border: 1px solid #c7ced4;
    color: #7f7f7f;
    border-radius: 4px;
    user-select: none;
    cursor: pointer;
    box-sizing: border-box;
    font-size: 14px;
    padding: 12px;
  }

  .options {
    position: absolute;
    z-index: 1;
    top: calc(100% + 2px);
    left: 0;
    width: calc(100% - 2px);
    max-height: 300px;
    overflow-y: auto;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    font-size: 14px;
  }

  .options > div {
    padding: 10px;
    cursor: pointer;
  }

  .options > div:hover {
    background-color: #f4f4f4;
  }

  .icon {
    position: absolute;
    right: 8px;
    height: 14px;
    transition: all 0.25s;
  }

  .with-icon {
    margin-left: 16px;
  }

  .parent-icon {
    position: absolute;
    left: 8px;
    top:12px;
  }

  .label {
    margin-right: 30px;
    top: -2px;
    position: relative;
  }

  .multi {
    top: -8px;
  }

  .select-search {
    width: calc(100% - 26px);
    height: 25px;
    margin: 6px 11px 2px 11px;
    background: #ffffff;
    border: 1px solid #e5e9eb;
    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
  }

  .pills {
    padding: 5px;
    background-color: #bcbcbc;
    margin: 2px;
    border-radius: 13px;
  }

  .close {
    background-color: red;
    color: white;
    margin-top: 0px;
    margin-left: 5px;
    border-radius: 50%;
    padding-top: 0;
    padding-bottom: 0px;
    padding-left: 2px;
    padding-right: 2px;
  }

  .hidden {
    display: none;
  }

  .rotate-down {
    transform: rotate(180deg);
  }

  .footer {
    position: sticky;
    bottom: 0px;
    bottom: 0;
    background: linear-gradient(0deg, #fafafa, #fafafa),
      linear-gradient(0deg, #e5e9eb, #e5e9eb);
    border: 1px solid #e5e9eb;
    display: flex;
    justify-content: space-between;
    cursor: default !important;
  }

  .clear {
    color: #005ea6;
    cursor: pointer;
    top: 4px;
    position: relative;
  }

  .selected{
    color:black;
  }
`;
